import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.93 2.5H17.07C17.9 2.5 18.35 3.47 17.81 4.1L12.33 10.53V16.5C12.33 17.05 11.88 17.5 11.33 17.5H9.67C9.12 17.5 8.67 17.05 8.67 16.5V10.53L3.19 4.1C2.65 3.47 3.1 2.5 3.93 2.5Z",
		fill: "currentColor"
	})
});
export default SvgFilter;
